import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-feedback-action-taken-report',
  templateUrl: './iqac-feedback-action-taken-report.component.html',
  styleUrls: ['./iqac-feedback-action-taken-report.component.scss']
})
export class IqacFeedbackActionTakenReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
